export class Adjust 
{
    constructor
    (
        {
          id= null,          
          matCode= ``,
          matName= ``,
          adjTime= ``,                  
          curInventory='',
          adjedInventory='',
          adjQuantity='',
          adjPerson=''
        } = {}
    ) 
    {
      this.id = id;     
      this.matCode = matCode;
      this.matName = matName;    
      this.adjTime = adjTime;     
      this.curInventory = curInventory;
      this.adjedInventory = adjedInventory;
      this.adjQuantity = adjQuantity;
      this.adjPerson = adjPerson;
    }
}
export function gridFields() 
{
    return Object.freeze([
        // {
        //   key: 'matCode',
        //   label: 'lbl.basic.matCode',
        //   sortable: true,  
        //   form: {
        //     type: 'input'
        //   }   
        // },
        {
          key: 'matName',
          label: 'lbl.basic.matName',
          sortable: true,
          form: {
            type: 'input'
          }
        },
        {
          key: 'adjTime',
          label: 'lbl.inventory.adjustTime',
          sortable: true,
          form: {
            type: 'datetimepicker'
          }
        }, 
        {
          key: 'locationCode',
          label: 'lbl.inventory.invCode',
          sortable: true,
          form: {
            type: 'input'
          }
        }, 
        {
          key: 'locationName',
          label: 'lbl.inventory.invName',
          sortable: true,
          form: {
            type: 'input'
          }
        }, 
        {
          key: 'curInventory',
          label: 'lbl.inventory.beforeInventory',
          sortable: true,
          form: {
            type: 'input'
          }
        },
        {
          key: 'adjedInventory',
          label: 'lbl.inventory.adjusted',
          sortable: true,
          form: {
            type: 'input'
          }
        },
        {
          key: 'adjQuantity',
          label: 'lbl.inventory.adjustQuantity',
          sortable: true,
          form: {
            type: 'input'
          }
        },
        {
          key: 'adjPerson',
          label: 'lbl.inventory.adjustPerson',
          sortable: false,
          form: {
            type: 'input'
          }
        }                 
    ]);
}
  export const fields = Object.freeze(Object.keys(new Adjust()).map(i => 'entity.' + i));
  export const filterFields = 
  [    
    // 'filter.matClassFilter',
    // 'filter.matCatalogFilter',
    'filter.matCodeFilter',
    // 'filter.matNameFilter',
    'filter.locationCodeFilter',
    'filter.adjStimeFilter',
    'filter.adjEtimeFilter',
    'filter.adjPersonFilter'
  ];
  export const filter = 
  {
    // 'matClassFilter': "",
    // 'matCatalogFilter': "",
    'matCodeFilter': "",
    // 'matNameFilter': "",
    'locationCodeFilter': "",
    'adjStimeFilter': "",
    'adjEtimeFilter': "",
    'adjPersonFilter':""
  };